/** The host that is authoritative for the active conversation identity. */
export type ConversationRouteOwner = 'host' | 'url';

/** The route-sensitive action required before dispatching a composer message. */
export type ComposerRouteTransition =
  | 'await_route_owner'
  | 'send_current_conversation'
  | 'start_route_owned_conversation';

/**
 * Resolves the URL handoff needed before a composer send.
 *
 * The global assistant owns its active conversation through `?c=…`. Hosts such
 * as the dossier dock and AI numbering wizard intentionally keep their active
 * id in React state and never write it to the URL. Keeping this explicit makes
 * a visually embedded global assistant safe: presentation never decides where
 * the conversation identity comes from.
 */
export function resolveComposerRouteTransition({
  conversationRouteOwner,
  browserConversationId,
  conversationId,
}: {
  conversationRouteOwner: ConversationRouteOwner;
  browserConversationId: string | null;
  conversationId: string | null;
}): ComposerRouteTransition {
  if (conversationRouteOwner === 'host') return 'send_current_conversation';
  if (browserConversationId === null && conversationId !== null) {
    return 'start_route_owned_conversation';
  }
  if (browserConversationId !== conversationId) return 'await_route_owner';
  return 'send_current_conversation';
}
